import {
  PortalDsBadge,
  type PortalDsBadgeVariant,
} from 'src/components/portal-design-system';

const STATUS_VARIANTS: Record<string, PortalDsBadgeVariant> = {
  pending: 'gray',
  running: 'blue',
  success: 'green',
  failed: 'red',
  skipped: 'gray',
  disabled: 'gray',
};

interface DataTransferStatusBadgeProps {
  status: string | null | undefined;
  disabled?: boolean;
}

export function DataTransferStatusBadge({ status, disabled = false }: DataTransferStatusBadgeProps) {
  const key = disabled ? 'disabled' : (status ?? 'pending');
  const variant = STATUS_VARIANTS[key] ?? 'gray';

  return (
    <PortalDsBadge variant={variant} pill>
      {key}
    </PortalDsBadge>
  );
}
